import React from "react";
import { useLanguage } from "../context/LanguageContext";

const PainSection = () => {
  const { language } = useLanguage();
  
  const content = {
    sl: {
      label: "VAM JE ZNANO?",
      title: "Če vam karkoli od tega krade spanec,",
      titleHighlight: "ste na pravem mestu.",
      description: "Večina podjetnikov nima težave z računovodstvom. Imajo težavo s časom, denarjem in gotovostjo — in prav pri papirjih vse to odteka.",
      descriptionBold: "časom, denarjem in gotovostjo",
      cards: [
        {
          num: "01",
          title: "Računovodja vam pove, kaj se je zgodilo — nikoli pa, kaj storiti naprej.",
          text: "Poročila pridejo z mesečno zamudo, v nerazumljivem jeziku — ko se ne da ničesar več spremeniti."
        },
        {
          num: "02",
          title: "DDV, ki vam pripada, ostaja nevrnjen.",
          text: "Gorivo, cestnine in storitve, plačane v tujini — pravi denar, izgubljen zaradi zamujenih rokov."
        },
        {
          num: "03",
          title: "Vloge za dovoljenja obtičijo, novi delavec pa čaka.",
          text: "En napačen obrazec in voznik tedne sedi doma — z njim pa tudi vaš prihodek."
        },
        {
          num: "04",
          title: "Dopisi FURS, ki jih ne razumete.",
          text: "Slovenska birokracija je zahtevna tudi za domačine. Brez strokovnjaka je minsko polje."
        },
        {
          num: "05",
          title: "Davek, ki pride kot presenečenje, ne kot načrt.",
          text: "Nihče vam ni povedal, koliko vas bo odločitev stala, preden ste jo sprejeli."
        },
        {
          num: "06",
          title: "Večeri in vikendi, izgubljeni med računi in obrazci.",
          text: "Ure, ki bi jih morali nameniti strankam, družini — ali preprosto počitku."
        }
      ]
    },
    en: {
      label: "SOUND FAMILIAR?",
      title: "If any of this keeps you up at night,",
      titleHighlight: "you're in the right place.",
      description: "Most business owners don't have an accounting problem. They have a time, money and certainty problem — and the paperwork is where it leaks out.",
      descriptionBold: "time, money and certainty",
      cards: [
        {
          num: "01",
          title: "Your accountant tells you what happened — never what to do next.",
          text: "Reports arrive months late, in jargon, when it's too late to change anything."
        },
        {
          num: "02",
          title: "VAT you're owed sits unclaimed.",
          text: "Fuel, tolls and services paid abroad — real money you could have back, lost to missed deadlines."
        },
        {
          num: "03",
          title: "Work-permit files stuck while your new hire waits.",
          text: "One wrong form and a driver or developer sits at home for weeks — and so does your revenue."
        },
        {
          num: "04",
          title: "Letters from FURS you can't read.",
          text: "Slovenian bureaucracy is hard enough in Slovenian. In a foreign language it's a minefield."
        },
        {
          num: "05",
          title: "Tax bills that show up as a surprise, not a plan.",
          text: "Nobody told you what that decision would cost before you made it."
        },
        {
          num: "06",
          title: "Evenings and weekends lost to receipts and forms.",
          text: "Hours you should be spending on customers, family — or simply not working."
        }
      ]
    }
  };
  
  const t = content[language] || content.sl;
  
  return (
    <section className="py-24 lg:py-32 px-6 lg:px-[120px] bg-[#F6F2EA]" data-testid="pain-section">
      <div className="max-w-[1440px] mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-end gap-8 lg:gap-20 mb-14 animate-on-scroll" data-animate-section>
          <div className="flex flex-col gap-5 max-w-[720px]">
            <span className="text-[13px] font-bold tracking-[2.5px] text-[#7A5B28]">{t.label}</span>
            <h2 className="font-serif text-4xl lg:text-[64px] leading-[1.02] tracking-[-1px] text-[#15181C]">
              {t.title} <span className="italic">{t.titleHighlight}</span>
            </h2>
          </div>
          <p className="text-[17px] leading-[1.65] text-[#4E5359] max-w-[380px]">
            {t.description.split(t.descriptionBold)[0]}
            <strong className="text-[#15181C]">{t.descriptionBold}</strong>
            {t.description.split(t.descriptionBold)[1]}
          </p>
        </div>
        
        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#D9D1C2] border border-[#D9D1C2]">
          {t.cards.map((card, index) => (
            <div 
              key={card.num}
              className={`bg-[#F6F2EA] p-8 lg:p-10 flex flex-col gap-3.5 animate-on-scroll delay-${Math.min(index + 1, 5)}`}
              data-testid={`pain-card-${index + 1}`}
            >
              <span className="font-serif text-[28px] text-[#7A5B28]">{card.num}</span>
              <h3 className="text-[21px] leading-[1.35] font-bold text-[#15181C]">{card.title}</h3>
              <p className="text-[15px] leading-[1.6] text-[#4E5359]">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainSection;
